import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariables } from 'global-variables';
import { Observable } from 'rxjs';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPopup, GoogleAuthProvider, Auth } from 'firebase/auth';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class LoginService {
    private firebaseApp = initializeApp(environment.firebaseConfig);
    public auth: Auth = getAuth(this.firebaseApp);

    private url = GlobalVariables.appURL;

    constructor(private _httpClient: HttpClient
    ) {

    }

    public login(data: any): any {
        return this._httpClient.post(this.url + 'customer-users/login', data);
    }

    public google_login(data: any): any {
        return this._httpClient.post(this.url + 'customer-users/signup-google', data);
    }

    public google_authentication(data: any): any {
        return this._httpClient.post(this.url + 'customer-users/signup-google', data);
    }

    public forgetPassword(data: any): any {
        return this._httpClient.post(this.url + 'customer-users/forgot-password', data);
    }

    public resetPassword(data: any): any {
        return this._httpClient.post(this.url + 'customer-users/reset-password', data);
    }

    public register(data: any, returnURL?: string): any {
        let url = this.url + 'customer-users/signup';

        if (returnURL)
            url += `?returnUrl=${encodeURIComponent(returnURL)}`;
        else
            url += `?returnUrl=""`;

        return this._httpClient.post(url, data);
    }

    public google_register(data: any, returnURL?: string): any {
        return this._httpClient.post(this.url + 'customer-users/signup-google', data);
    }

    public verify_user(token: string): Observable<Object> {
        return this._httpClient.post(this.url + 'users/verify', { token });
    }

    googleLogin() {
        return signInWithPopup(this.auth, new GoogleAuthProvider());
    }

    public check_auth_method(data: any): any {
        return this._httpClient.post(this.url + 'customer-users/auth/check-method', data);
    }

    async logout() {
        try {
            await this.auth.signOut();
            console.log('User signed out successfully');
        } catch (error) {
            console.error('Logout Error:', error);
        }
    }
}

